import { Flex } from "antd";
import { FC } from "react";
import { shallowEqual } from "react-redux";
import { MotivationGroupsInfo, SalaryToPaid } from "tm-shared/types";
import {
    formatNumber,
    formatUAHNumber,
    formatUAHStandard,
} from "tm-shared/utils";

import {
    DashboardCollapse,
    DashboardCollapseListItem,
} from "@/features/Dashboard/components/DashboardCollapse";
import { DashboardProgress } from "@/features/Dashboard/components/DashboardProgress";
import { useAppSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledMMLValue } from "./Styled";

interface IMMLCollapseProps {
    source: "manager" | "work";
    motivation?: MotivationGroupsInfo | null;
    salary?: SalaryToPaid | null;
}

export const MMLCollapse: FC<IMMLCollapseProps> = ({
    source,
    motivation: motivationProp,
    salary: salaryProp,
}) => {
    const workData = useAppSelector(
        (state) => ({
            motivation: state.work.motivation,
            salary: state.work.salary,
        }),
        shallowEqual,
    );
    const managerData = useAppSelector(
        (state) => ({
            motivation: state.manager.motivation,
            salary: state.manager.salary,
        }),
        shallowEqual,
    );
    const stateVal = source === "manager" ? managerData : workData;

    const motivation =
        motivationProp !== undefined ? motivationProp : stateVal.motivation;
    const salary = salaryProp !== undefined ? salaryProp : stateVal.salary;
    const mmlStatistics = motivation?.mml;

    const items: DashboardCollapseListItem[] = [
        {
            label: "Загальна кількість точок * СКЮ:",
            value: formatNumber(mmlStatistics?.statistic?.plan),
        },
        {
            label: "Виконано точок * СКЮ:",
            value: formatUAHNumber(mmlStatistics?.statistic?.fact ?? 0),
        },
        {
            label: "Відсоток виконання:",
            value: `${formatNumber(mmlStatistics?.statistic?.percent, 2)} %`,
        },
        {
            label: "Зараховується від:",
            value: `${formatNumber(
                mmlStatistics?.configuration?.minComplete,
                2,
            )} %`,
        },
        {
            label: "Коефіцієнт бонусу:",
            value: mmlStatistics?.configuration?.bonusCoefficient || 0,
        },
        ...(mmlStatistics?.configuration?.fineCoefficient !== 1
            ? [
                  {
                      label: "Коефіцієнт штрафу:",
                      value: mmlStatistics?.configuration?.fineCoefficient || 0,
                  },
              ]
            : []),
        {
            label: "Вплив MML:",
            value: formatUAHStandard(salary?.mmlBonus ?? 0),
        },
    ];

    return (
        <DashboardCollapse
            header={
                <Flex
                    style={{ width: "100%" }}
                    vertical
                    gap="4px"
                    align="flex-start"
                    justify="flex-start"
                >
                    <Flex
                        style={{ width: "100%" }}
                        justify="space-between"
                        align="center"
                    >
                        <PrimaryText fontWeight="400" fontSize={14}>
                            Виконання MML Стандарту:
                        </PrimaryText>
                        <StyledMMLValue fontWeight="500" fontSize={16}>
                            {formatUAHStandard(salary?.mmlBonus ?? 0)}
                        </StyledMMLValue>
                    </Flex>

                    <DashboardProgress
                        value={Math.round(
                            mmlStatistics?.statistic?.percent || 0,
                        )}
                        limit={mmlStatistics?.configuration?.minComplete || 0}
                    />
                </Flex>
            }
            items={items}
        />
    );
};
